import React from 'react';
import { Card, Spin, Typography } from 'antd';

interface ViewProps {
    children?: React.ReactNode;
    title?: string;
    message?: string;
    icon?: React.ReactNode;
    EmptyStateBody?: React.ReactNode; // Nueva propiedad para el cuerpo del estado vacío
    EmptyStateSecondaryActions?: React.ReactNode; // Acción secundaria opcional
    loading?: boolean;
}

export const EmptyState: React.FunctionComponent<ViewProps> = (props) => {
    const { Title } = Typography;
    const titleString = props.title || 'Obteniendo Información del Servidor';

    return (
        <Card style={{ textAlign: 'center', padding: '50px' }}>
            { props.loading && <Spin size="large" /> }

            {props.icon && <div style={{ margin: '20px 0', fontSize: 80 }}>{props.icon}</div>}
            <Title level={4}>{props.message || titleString}</Title>
            {props.children && (
                <div>
                    {props.children}
                </div>
            )}
            {props.EmptyStateBody && (
                <div style={{ marginTop: '20px' }}>
                    {props.EmptyStateBody}
                </div>
            )}
            {props.EmptyStateSecondaryActions && (
                <div style={{ marginTop: '20px' }}>
                    {props.EmptyStateSecondaryActions}
                </div>
            )}
        </Card>
    );
};
